import React from 'react';
import { connect } from 'react-redux';

import SystemPopupView from '../../components/modals/SystemPopupView';
import NotificationsAnnouncementModal from '../../components/modals/AnnouncementModal/NotificationsAnnouncementModal';
import MobileFilesAnnouncementModal from '../../components/modals/AnnouncementModal/MobileFilesAnnouncementModal';
import FeatureWalkthrough from '../../components/modals/FeatureWalkthrough';
import FileUploadModal from '../../components/modals/FileUploadModal';
import TemplatePublishModal from '../../components/modals/TemplatePublishModal';
import UserSettingsModal from '../../components/modals/UserSettingsModal';
import HandsFreeErrorModal from '../../components/modals/HandsFreeErrorModal';

import ModalBannerConstants from '../../constants/ModalBannerConstants';

const MODAL_COMPONENTS = {
  [ModalBannerConstants.NOTIFICATIONS_ANNOUNCEMENT_MODAL]: NotificationsAnnouncementModal,
  [ModalBannerConstants.MOBILE_FILES_ANNOUNCEMENT_MODAL]: MobileFilesAnnouncementModal,
  [ModalBannerConstants.SYSTEM_POPUP]: SystemPopupView,
  [ModalBannerConstants.FEATURE_WALKTHROUGH]: FeatureWalkthrough,
  [ModalBannerConstants.FILE_UPLOADER]: FileUploadModal,
  [ModalBannerConstants.TEMPLATE_PUBLISH_MODAL]: TemplatePublishModal,
  [ModalBannerConstants.USER_SETTINGS_MODAL]: UserSettingsModal,
  [ModalBannerConstants.HANDSFREE_ERROR_MODAL]: HandsFreeErrorModal,
};

export function GlobalModal({ modalType, modalProps }) {
  if(!modalType) {
    return null;
  }
  const SpecificModal = MODAL_COMPONENTS[modalType];
  return <SpecificModal {...modalProps} />;
}

export default connect(
  state => state.main.globalModal
)(GlobalModal);



// WEBPACK FOOTER //
// ./src/containers/GlobalModal/index.js